// meals.config.js
import React from "react";
import {
  BreakfastDining as BreakfastDiningIcon,
  LocalDining as LocalDiningIcon,
  DinnerDining as DinnerDiningIcon,
  Cookie as CookieIcon,
  Cake as CakeIcon,
  Fastfood as FastfoodIcon,
  RestaurantMenu as RestaurantMenuIcon,
} from "@mui/icons-material";

export const MealOptions = [
  {
    value: "Breakfast",
    label: "Breakfast",
    icon: <BreakfastDiningIcon sx={{ fontSize: 20 }} />,
    color: "#F59E0B",
  },
  {
    value: "Brunch",
    label: "Brunch",
    icon: <RestaurantMenuIcon sx={{ fontSize: 20 }} />,
    color: "#F97316",
  },
  {
    value: "Lunch",
    label: "Lunch",
    icon: <LocalDiningIcon sx={{ fontSize: 20 }} />,
    color: "#3B82F6",
  },
  {
    value: "Dinner",
    label: "Dinner",
    icon: <DinnerDiningIcon sx={{ fontSize: 20 }} />,
    color: "#8B5CF6",
  },
  {
    value: "Supper",
    label: "Supper",
    icon: <DinnerDiningIcon sx={{ fontSize: 20 }} />,
    color: "#7C3AED",
  },
  {
    value: "Snack",
    label: "Snack",
    icon: <CookieIcon sx={{ fontSize: 20 }} />,
    color: "#EC4899",
  },
  {
    value: "Dessert",
    label: "Dessert",
    icon: <CakeIcon sx={{ fontSize: 20 }} />,
    color: "#F472B6",
  },
  {
    value: "Other",
    label: "Other",
    icon: <FastfoodIcon sx={{ fontSize: 20 }} />,
    color: "#6B7280",
  },
];

export const getMealIcon = (type) => {
  const meal = MealOptions.find((m) => m.value === type);
  return meal?.icon || <FastfoodIcon sx={{ fontSize: 20 }} />;
};

export const getMealColor = (type) => {
  const meal = MealOptions.find((m) => m.value === type);
  return meal?.color || "#6B7280";
};